import React from "react";
import "./Common_breadcrumb.css"
import { Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";

function Common_breadcrumb({ items }) {
  return (
    <section className="Common_breadcrumb">
      <Breadcrumb>
        {items.map((item, index) => (
          <Breadcrumb.Item
            key={index}
            linkAs={item.link ? Link : "span"}
            linkProps={item.link ? { to: item.link } : {}}
            active={!item.link}
          >
            {item.label}
          </Breadcrumb.Item>
        ))}
      </Breadcrumb>
    </section>
  );
}

export default Common_breadcrumb;
